<template>
  <div class="TipsAndPrivewDilog">
    <div class="name">
      <div v-if="IsShowExternalSolt">
        <slot name="ExternalSolt"></slot>
      </div>
      <div v-else class="TipsAndPrivewDilog__inline">
        <slot name="Text"></slot>
        <span
          v-if="IconUrl == ''"
          class="TipsAndPrivewDilog__icon-wrap"
        >
          <i
            v-if="Type == 1"
            class="fa fa-info-circle m-l-5 TipsAndPrivewDilog__icon"
            v-bind:t_label="id"
            v-b-toggle="sidebarId"
          ></i>
          <i
            v-else
            ref="iconRef"
            class="fa fa-info-circle ml-1 TipsAndPrivewDilog__icon"
            v-bind:t_label="id"
            @mouseenter="showTooltip"
            @mouseleave="hideTooltip"
            @mousemove="updateTooltipPosition"
          ></i>
        </span>
        <span
          v-else
          class="TipsAndPrivewDilog__icon-wrap"
        >
          <img
            ref="iconRef"
            v-bind:t_label="id"
            class="TipsAndPrivewDilog__icon-img"
            :src="IconUrl"
            @mouseenter="showTooltip"
            @mouseleave="hideTooltip"
            @mousemove="updateTooltipPosition"
          >
        </span>
      </div>
    </div>

    <b-sidebar
      v-if="Type == 1"
      :visible="false"
      :id="sidebarId"
      :title="DilogTitle"
      v-b-toggle="'Privew_Page'"
      right
      bg-variant="white"
      :shadow="true"
      @shown="scrollToAdPosition"
      backdrop
      ref="Dialog"
    >
      <div class="tab-pane active">
        <div class="card shadow-none">
          <div class="card-body">
            <img :src="Url" width="100%" />
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  props: {
    Type: {
      type: Number,
      default: 0
    },
    Url: {
      type: String,
      default: ""
    },
    Title: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    DilogTitle: {
      type: String,
      default: ""
    },
    IsShowExternalSolt: {
      type: Boolean,
      default: false
    },
    scrollToNums: {
      type: Number,
      default: 0
    },
    IconUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      bodyTooltipEl: null,
    };
  },
  computed: {
    sidebarId() {
      // 与外部「样本」按钮 v-b-toggle 的 id 一致（广告详情 / 各广告类型页）
      return this.id;
    },
  },
  beforeDestroy() {
    this.destroyBodyTooltip();
  },
  methods: {
    ensureBodyTooltip() {
      if (this.bodyTooltipEl) return this.bodyTooltipEl;

      const root = document.createElement('div');
      root.className = 'tips-preview-tooltip';
      root.style.display = 'none';

      const content = document.createElement('div');
      content.className = 'tips-preview-tooltip__content';
      root.appendChild(content);

      const arrow = document.createElement('div');
      arrow.className = 'tips-preview-tooltip__arrow';
      root.appendChild(arrow);

      document.body.appendChild(root);
      this.bodyTooltipEl = root;
      return root;
    },
    destroyBodyTooltip() {
      if (this.bodyTooltipEl && this.bodyTooltipEl.parentNode) {
        this.bodyTooltipEl.parentNode.removeChild(this.bodyTooltipEl);
      }
      this.bodyTooltipEl = null;
    },
    scrollToAdPosition() {
      if (this.$refs.Dialog && this.$refs.Dialog.$el) {
        const sidebarContent = this.$refs.Dialog.$el.querySelector('.b-sidebar-body')
          || this.$refs.Dialog.$el.querySelector('.card-body');
        if (sidebarContent) {
          sidebarContent.scrollTo({
            top: this.scrollToNums,
            left: 0,
            behavior: 'smooth'
          });
        }
      }
    },
    showTooltip(event) {
      if (this.Type !== 0 || !this.Title) return;

      const tooltip = this.ensureBodyTooltip();
      const content = tooltip.querySelector('.tips-preview-tooltip__content');
      if (content) {
        content.innerHTML = this.Title;
      }
      tooltip.style.display = 'block';
      this.$nextTick(() => {
        this.updateTooltipPosition(event);
      });
    },
    hideTooltip() {
      if (this.bodyTooltipEl) {
        this.bodyTooltipEl.style.display = 'none';
      }
    },
    updateTooltipPosition(event) {
      const tooltip = this.bodyTooltipEl;
      const icon = event && event.target
        ? event.target
        : this.$refs.iconRef;
      if (!tooltip || tooltip.style.display === 'none' || !icon) return;

      const iconRect = icon.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      const fallbackWidth = 280;
      const fallbackHeight = 48;
      const width = tooltipRect.width || fallbackWidth;
      const height = tooltipRect.height || fallbackHeight;

      let top = iconRect.bottom + 8;
      let left = iconRect.left + (iconRect.width / 2) - (width / 2);

      const padding = 10;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      if (left < padding) {
        left = padding;
      } else if (left + width > viewportWidth - padding) {
        left = viewportWidth - width - padding;
      }

      if (top + height > viewportHeight - padding) {
        top = iconRect.top - height - 8;
      }
      if (top < padding) {
        top = padding;
      }

      tooltip.style.position = 'fixed';
      tooltip.style.top = `${top}px`;
      tooltip.style.left = `${left}px`;
      tooltip.style.zIndex = '100000';
    },
  },
};
</script>

<style lang="scss" scoped>
.TipsAndPrivewDilog__inline {
  display: inline;
}

.TipsAndPrivewDilog__icon-wrap {
  display: inline-block;
  position: relative;
  vertical-align: middle;
}

.TipsAndPrivewDilog__icon,
.TipsAndPrivewDilog__icon-img {
  cursor: help;
  pointer-events: auto;
  position: relative;
  z-index: 1;
}

.TipsAndPrivewDilog__icon-img {
  padding: 4px;
  margin-top: -2px;
  vertical-align: middle;
}
</style>

<style lang="scss">
.tips-preview-tooltip {
  position: fixed;
  pointer-events: none;
  max-width: 350px;
}

.tips-preview-tooltip__content {
  background: var(--theme-deafult, #7366ff);
  color: #fff;
  border: 1px solid var(--theme-deafult, #7366ff);
  font-size: 14px;
  line-height: 1.3;
  padding: 8px 12px;
  border-radius: 4px;
  white-space: normal;
  text-align: left;
}

.tips-preview-tooltip__arrow {
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 6px 6px 6px;
  border-color: transparent transparent var(--theme-deafult, #7366ff) transparent;
}
</style>
